import script from "./sf-indicator-new.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-indicator-new.vue?vue&type=script&setup=true&lang=ts"

import "./sf-indicator-new.vue?vue&type=style&index=0&id=c75dfb40&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c75dfb40"]])

export default __exports__